import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { useNavStackMobileAccount } from './nav-stack-mobile-account.logic.ts';
export const MobileAccountSection = () => {
  const $ = _c(4);
  const {
    mobileAccountItems
  } = useNavStackMobileAccount();
  let t0;
  if ($[0] !== mobileAccountItems) {
    t0 = mobileAccountItems.map(_temp);
    $[0] = mobileAccountItems;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="NavStack__mobile-accounts-section py-comfy-sm"><div className="flex flex-col gap-snug-xl">{t0}</div></div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp(item) {
  return <button key={item.id} type="button" className="NavStack__link flex justify-between items-center w-full px-comfy-sm sm:px-comfy-xl py-snug-xl" onClick={item.action}><span className="NavStack__text label-neutral label-potent label-xl">{item.label}</span><span className="NavStack__next-button p-comfy-xs"><ArkIcon iconName="arrow-right" /></span></button>;
}